import { render, staticRenderFns } from "./NoticeContent.vue?vue&type=template&id=ceba152a&scoped=true&"
import script from "./NoticeContent.vue?vue&type=script&lang=js&"
export * from "./NoticeContent.vue?vue&type=script&lang=js&"
import style0 from "./NoticeContent.vue?vue&type=style&index=0&id=ceba152a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ceba152a",
  null
  
)

export default component.exports